
import { Component, OnInit, Input, OnChanges, SimpleChanges, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import * as moment from "moment";

import { SharedService } from '@services/shared.service';
import { ApiTransactionService } from '@services/api-transaction.service';

import { TicketModel } from '@models/TicketModel';
import { EventModel } from '@models/EventModel';
import { EventFormatType } from '@shared/models/Enums';


@Component({
    selector: 'app-tickets-selector',
    templateUrl: './tickets-selector.component.html',
    styleUrls: ['./tickets-selector.component.scss']
})
export class TicketsSelectorComponent implements OnInit, OnChanges {

    @Output() onChanged: EventEmitter<TicketModel[]> = new EventEmitter<TicketModel[]>();

    @Input() event: EventModel;
    @Input() tickets: TicketModel[];

    @Input() darkMode = false;

    isExpanded = false;

    selectedTickets: TicketModel[] = [];
    selectedTicket: TicketModel;

    noImage = 'assets/images/noimage-card.png';

    title = '';

    ticketsReadyToSale: { id: number, timeText: string }[] = [];

    constructor(public router: Router,
        public modalService: NgbModal,
        public sharedService: SharedService,
        public apiTransactionService: ApiTransactionService) {
    }

    get availableQuantity(): number {

        const quantity = this.event.stock - this.event.quantity;
        return quantity;
    }

    get total(): number {

        // Suma el precioTotal de cada ticket
        const total = this.selectedTickets.reduce((priceTotal, ticket) => {

            priceTotal += ticket.priceTotal;
            return priceTotal;
        }, 0);

        return total;
    }

    ngOnInit() {

        this.event = new EventModel(this.event);

        this._init();
    }

    ngOnChanges(changes: SimpleChanges): void {

        for (const propName in changes) {
            if (propName === 'tickets') {
                const change = changes[propName];
                if (!change.isFirstChange() && (change.previousValue !== change.currentValue)) {

                    if (this.event.vendor != null) {

                        this.tickets.forEach(x => {
                            if (x.vendor == null) x.vendor = this.event.vendor;
                        });
                    }

                    this._init();
                }
            }
        }
    }

    closeModalProduct() {

        this.sharedService.setEventForModal(null);
    }

    onChangeQuantity(ticket: TicketModel) {

        /* Filtra los tickets y devuelve solo los tickets que tienen la cantidad
        seleccionada mayor que 0. */
        this.selectedTickets = this.tickets.reduce((tickets, ticket) => {

            if (ticket.quantitySelected > 0) {
                tickets.push(ticket);
            }
            return tickets;
        }, []);

        this.onChanged.next(this.selectedTickets)
    }

    goToVendor(id) {
        this.router.navigate(['event/store', id]);
    }

    infoOpen(ticket: TicketModel) {

        const title = this.event.format == EventFormatType.Membership ?
            'Descripción de la membresía' :
            'Descripción de la entrada';

        this.sharedService.showInfoTicketsAlert(title, ticket.name, ticket.description, this.darkMode);
    }

    getReadyToSaleTimeText(ticket: TicketModel): string {

        let readyToSaleTimeText = this.ticketsReadyToSale.find(x => x.id == ticket.id);
        if (readyToSaleTimeText) {
            return readyToSaleTimeText.timeText;
        }
        return null
    }

    toggleDesc() {

        this.isExpanded = !this.isExpanded;
    }

    onClose() {
        this.modalService.dismissAll()
    }

    onOpen(modal) {

        this.modalService.open(modal, {
            centered: true, size: 'xs', windowClass: 'modal-full'
        });
    }

    onSendMessage(whatsappPhone: string): void {

        const whatsappUrl = `https://wa.me/${whatsappPhone}`;
        window.location.href = whatsappUrl;
    }


    private _init() {

        if (this.tickets?.length) {

            // Se selecciona el primer ticket como default
            this.selectedTicket = this.tickets[0];
            //this.vendorStores = this.selectedTicket ? this.selectedTicket.stores : [];

            // TEST: mostrar pronto
            // if(this.selectedTicket?.id == 51){
            //     this.selectedTicket.saleDateStartAt = new Date(2024, 2);
            // }

            // Timer para cada 1000 milisegundos (1 segundo)
            setInterval(() => {
                this.tickets.forEach(x => { if (x.isIncoming) this._updateCountdowns(x); });
            }, 1000);
        }
    }

    private _updateCountdowns(ticket: TicketModel): void {

        if (ticket.isIncoming) {

            //function to create the crono using the lib moment
            let timeToReadyToSale = moment(ticket.saleDateStartAt);
            const timeDifference = timeToReadyToSale.diff(moment());

            //if the timeToReadyToSale  is other we validate the hours.
            if (timeDifference > 0) {

                let readyToSaleTimeText = this.ticketsReadyToSale.find(x => x.id == ticket.id);
                if (!readyToSaleTimeText) {
                    readyToSaleTimeText = { id: ticket.id, timeText: '' };
                    this.ticketsReadyToSale.push(readyToSaleTimeText);
                }

                const duration = moment.duration(timeDifference);
                const totalDays = duration.months() * 30 + duration.days();
                if (totalDays > 0) {
                    readyToSaleTimeText.timeText = `${totalDays}d : ${duration.hours()}h : ${duration.minutes()}m`;
                } else {
                    readyToSaleTimeText.timeText = `${duration.hours()}h : ${duration.minutes()}m : ${duration.seconds()}s`;
                }
            }
        }
    }
}
